export enum FnTagVariants {
  Default = 'default',
  Outline = 'outline'
}
